/**
 * GSAP Horizontal Scroll Trigger
 * Creates horizontal scrolling effect triggered by vertical scroll
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

/**
 * Initialize horizontal scroll for all elements with data-horizontal-scroll
 */
export function initHorizontalScroll() {
    const containers = document.querySelectorAll('[data-horizontal-scroll]');
    
    if (!containers.length) return;
    
    containers.forEach((container) => {
        const track = container.querySelector('.horizontal-scroll__track');
        if (!track) return;
        
        // Calculate scroll amount dynamically
        const getScrollAmount = () => track.scrollWidth - container.offsetWidth;
        
        // Only initialize if there is content to scroll
        if (getScrollAmount() > 0) {
            gsap.to(track, {
                x: () => -getScrollAmount(),
                ease: "none",
                scrollTrigger: {
                    trigger: container,
                    start: "center center",
                    end: () => `+=${getScrollAmount()}`,
                    pin: true,
                    pinSpacing: true,
                    scrub: 1,
                    invalidateOnRefresh: true,
                    onUpdate: self => {
                        container.classList.toggle('is-scrolling', self.isActive);
                    }
                }
            });
        }
    });
    
    // Refresh ScrollTrigger on resize
    window.addEventListener('resize', () => ScrollTrigger.refresh());
}

// Export for manual initialization
export default initHorizontalScroll;
